export default "__VITE_ASSET__DVvfipp5__"